export const ADD_COLLECTION = 'COLLECTION/ADD_COLLECTION'
export const UPDATE_COLLECTION = 'COLLECTION/UPDATE_COLLECTION'
export const LOAD_COLLECTIONS = 'COLLECTION/LOAD_COLLECTIONS'
export const LOAD_COLLECTIONS_SUCCESS = 'COLLECTION/LOAD_COLLECTIONS_SUCCESS'
export const LOAD_COLLECTIONS_FAILED = 'COLLECTION/LOAD_COLLECTIONS_FAILED'
